export type UnsupportedBank = {
  name: string;
  arabic_name: string | null;
  identifier: string;
  logo_alt: string;
  is_active: boolean;
};

export const unsupportedBanks: UnsupportedBank[] = [];
